const errorTypes = {
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  SYSTEM_ERROR: 'SYSTEM_ERROR',
  SYSTEM_ERROR_TRANSLATED: 'SYSTEM_ERROR_TRANSLATED',
};

export default errorTypes;
